import { css } from 'styled-components';
import { colors } from '../../colors';
import { cssfonts } from '../cssfonts';

const common = css`
  font-size: 0.875rem; /* 14px */
  line-height: 1.3; /* 14/18 */
`;

export const body3 = {
  extrabold: css`
    ${cssfonts.exbold}
    ${common}
  `,
  bold: css`
    ${cssfonts.bold}
    ${common}
  `,
  link: css`
    ${cssfonts.bold}
    ${common}
    
    &:hover {
      ${colors.$e60000}
    }
  `,
  regular: css`
    ${cssfonts.regular}
    ${common}
  `,
} as const;

